<template>
  <div class="page-wrapper user-center-page">
    <el-header class="page-header">
      <div class="header-content">
        <div class="section-title">个人中心</div>
        <el-button
          type="primary"
          size="medium"
          @click="logout"
          class="logout-btn"
          >退出登录</el-button
        >
      </div>
    </el-header>

    <el-main class="page-main">
      <div class="user-profile-card">
        <!-- 用户基础信息头 -->
        <div class="profile-header">
          <div class="avatar-wrapper">
            <img
              src="@/assets/img/touxiang-.png"
              alt="头像"
              class="avatar-img"
              @error="handleAvatarError"
            />
          </div>
          <div class="profile-info">
            <h2 class="user-name">{{ infoList.userName || "未知用户" }}</h2>
            <p class="user-no-text">学号：{{ infoList.studentNo || "---" }}</p>
          </div>
        </div>

        <!-- 详细信息网格表 -->
        <div class="info-grid-container">
          <div class="info-grid">
            <div class="grid-item label">姓名</div>
            <div class="grid-item value">{{ infoList.userName || "---" }}</div>
            <div class="grid-item label">学号</div>
            <div class="grid-item value">{{ infoList.studentNo || "---" }}</div>

            <div class="grid-item label">学校</div>
            <div class="grid-item value">
              {{ infoList.collegeName || "---" }}
            </div>
            <div class="grid-item label">专业</div>
            <div class="grid-item value">{{ infoList.majorName || "---" }}</div>

            <div class="grid-item label">年级</div>
            <div class="grid-item value">{{ infoList.gradeName || "---" }}</div>
            <div class="grid-item label">班级</div>
            <div class="grid-item value">{{ infoList.className || "---" }}</div>

            <div class="grid-item label">邮箱</div>
            <div class="grid-item value">
              <span v-if="infoList.email" class="info-text">{{
                infoList.email
              }}</span>
              <el-link
                type="primary"
                :underline="false"
                @click="onReadyModifyEmail"
                class="action-link"
              >
                {{ infoList.email ? "更换邮箱" : "绑定邮箱" }}
              </el-link>
            </div>
            <div class="grid-item label">密码</div>
            <div class="grid-item value">
              <el-link
                type="primary"
                :underline="false"
                @click="dialogVisiblePassWord = true"
                class="action-link"
                >修改密码</el-link
              >
            </div>

            <div class="grid-item label last-row">电话号码</div>
            <div class="grid-item value last-row full-width">
              <span class="info-text">{{
                infoList.hiddenPhone || "未绑定"
              }}</span>
              <el-link
                type="primary"
                :underline="false"
                @click="dialogVisiblePhone = true"
                class="action-link"
                >更换</el-link
              >
            </div>
          </div>
        </div>
      </div>
    </el-main>

    <!-- 原有对话框保持不变 -->
    <el-dialog
      title="验证手机号"
      :visible.sync="dialogVisiblePhone"
      width="400px"
      custom-class="premium-dialog"
    >
      <div class="dialog-info-text">{{ infoList.hiddenPhone }}</div>
      <el-form
        :rules="phoneRules"
        ref="phoneRulesForm"
        :model="phoneList"
        label-position="top"
      >
        <el-form-item label="补全旧手机号" prop="hiddenPhoneN">
          <el-input
            v-model="phoneList.hiddenPhoneN"
            maxlength="4"
            placeholder="请输入中间四位手机号"
          ></el-input>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="dialogVisiblePhone = false">取 消</el-button>
          <el-button type="primary" @click="changePhone">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="dialogVisiblePhone2"
      width="400px"
      custom-class="premium-dialog"
    >
      <el-form
        :rules="phoneRules"
        ref="phoneRulesForm2"
        :model="phoneList"
        label-position="top"
      >
        <el-form-item label="新手机号" prop="phone">
          <el-input
            v-model="phoneList.phone"
            maxlength="11"
            placeholder="请输入修改的手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code-input-wrapper">
            <el-input
              v-model="phoneList.code"
              maxlength="6"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              @click="btnClcik()"
              :disabled="isDisable"
              class="get-code-btn"
              >{{ tips }}</el-button
            >
          </div>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="submitPhone">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisiblePassWord"
      width="400px"
      custom-class="premium-dialog"
    >
      <el-form
        :rules="phoneRules"
        ref="NumRulesForm"
        :model="phoneList"
        label-position="top"
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="phoneList.password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code-input-wrapper">
            <el-input
              v-model="phoneList.code"
              maxlength="6"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              @click="btnIdClcik()"
              :disabled="isDisable"
              class="get-code-btn"
              >{{ tips }}</el-button
            >
          </div>
          <div class="phone-hint">
            验证码将发送至：{{ infoList.hiddenPhone }}
          </div>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="changePassword">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改邮箱"
      :visible.sync="dialogVisibleEmail"
      width="400px"
      custom-class="premium-dialog"
    >
      <el-form
        :rules="mailRules"
        ref="mailRulesForm"
        :model="maildata"
        label-position="top"
      >
        <el-form-item
          :label="maildata.verify ? '解绑原邮箱' : '绑定新邮箱'"
          prop="mail"
        >
          <el-input
            v-model="maildata.mail"
            :placeholder="maildata.verify ? '' : '请输入新邮箱地址'"
            :disabled="maildata.verify"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code-input-wrapper">
            <el-input
              v-model="maildata.code"
              maxlength="6"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              @click="btnEmailCodeClick()"
              :disabled="isEmailDisable"
              class="get-code-btn"
              >{{ emailTips }}</el-button
            >
          </div>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="btnEmailCancel()">取 消</el-button>
          <el-button type="primary" @click="handleEmailSubmit">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentInfo,
  sendPhone,
  sendStudentno,
  changepwd,
  setStudentEmail,
  studentChangePassword
} from "@/api/student";
import { sendCode, sendEmailCode } from "@/api/login";
import { IsEmptyString, validateEmail } from "@/util/stringutl.js";

export default {
  name: "UserIndex",
  data() {
    return {
      infoList: {},
      dialogVisibleNum: false,
      dialogVisiblePhone2: false,
      dialogVisiblePassWord: false,
      dialogVisiblePhone: false,
      tips: "获取验证码",
      isDisable: false,
      isEmailDisable: false,
      emailTips: "获取验证码",
      dialogVisibleEmail: false,
      maildata: {
        mail: "",
        code: "",
        password: "",
        verify: false
      },
      phoneList: {
        phone: "",
        code: "",
        hiddenPhone: "",
        hiddenPhoneN: "",
        newstudentno: "",
        password: ""
      },
      phoneRules: {
        code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "验证码格式错误", trigger: "blur" }
        ],
        hiddenPhoneN: [
          { required: true, message: "手机号不能为空", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            pattern: /^1[3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号格式错误",
            trigger: "blur"
          }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      mailRules: {
        mail: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z]{2,6}$/,
            message: "邮箱格式错误",
            trigger: "change"
          }
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.loadStudentInfo();
  },
  methods: {
    loadStudentInfo() {
      getStudentInfo().then(res => {
        this.infoList = res.data || {};
        this.maildata.mail = this.infoList.email || "";
        this.maildata.verify =
          !IsEmptyString(this.infoList.email) &&
          validateEmail(this.infoList.email);
        if (this.infoList.phone) {
          const reg = /^(\d{3})\d{4}(\d{4})$/;
          this.infoList.hiddenPhone = this.infoList.phone.replace(
            reg,
            "$1****$2"
          );
        }
      });
    },
    handleAvatarError(e) {
      e.target.src =
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
    },
    onReadyModifyEmail() {
      this.dialogVisibleEmail = true;
    },
    btnEmailCodeClick() {
      if (!this.maildata.mail || !validateEmail(this.maildata.mail)) {
        this.$message.warning("请先输入正确的邮箱地址");
        return;
      }
      this.isEmailDisable = true;
      let count = 60;
      this.emailTips = `${count}s后重发`;
      let timer = setInterval(() => {
        count--;
        if (count <= 0) {
          clearInterval(timer);
          this.isEmailDisable = false;
          this.emailTips = "获取验证码";
        } else {
          this.emailTips = `${count}s后重发`;
        }
      }, 1000);

      sendEmailCode(this.maildata.mail)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("验证码已发送至邮箱");
          } else {
            this.$message.error(res.message || "获取验证码失败");
            this.isEmailDisable = false;
            this.emailTips = "获取验证码";
            clearInterval(timer);
          }
        })
        .catch(() => {
          this.isEmailDisable = false;
          this.emailTips = "获取验证码";
          clearInterval(timer);
        });
    },
    handleEmailSubmit() {
      if (!this.maildata.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      // if (this.maildata.code !== this.emailVerifyCode) {
      //   this.$message.error("验证码不匹配");
      //   return;
      // }

      if (this.maildata.verify) {
        // 解绑流程：后端现在的逻辑是，解绑也需要验证码，但接口目前只针对 setStudentEmail。
        // 为了保持逻辑一致，我们直接将 verify 置为 false，让用户输入新邮箱再次验证。
        this.maildata.verify = false;
        this.maildata.mail = "";
        this.maildata.code = "";
        this.$message.success("验证成功，请输入新邮箱");
      } else {
        // 绑定逻辑
        setStudentEmail(this.maildata.mail, this.maildata.code).then(res => {
          if (res.code === 200) {
            this.$message.success("邮箱绑定成功");
            this.loadStudentInfo();
            this.dialogVisibleEmail = false;
            this.maildata.code = "";
          } else {
            this.$message.error(res.message || "绑定失败");
          }
        });
      }
    },
    btnEmailCancel() {
      this.dialogVisibleEmail = false;
      this.maildata.code = "";

      this.loadStudentInfo();
    },
    logout() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "premium-confirm"
      })
        .then(() => {
          window.sessionStorage.clear();
          window.localStorage.clear();
          this.$router.push("/login");
        })
        .catch(() => {});
    },
    changePassword() {
      if (this.phoneList.password && this.phoneList.code) {
        changepwd({
          phone: this.infoList.phone,
          code: this.phoneList.code,
          password: this.phoneList.password
        }).then(res => {
          this.$message.success("修改成功");
          this.dialogVisiblePassWord = false;
          this.phoneList.password = "";
          this.phoneList.code = "";
        });
      } else {
        this.$message.warning("请输入新密码和验证码");
      }
    },
    async btnIdClcik() {
      if (this.infoList.phone) {
        this.isDisable = true;
        let count = 60;
        this.tips = `${count}s`;
        let timer = setInterval(() => {
          count--;
          if (count <= 0) {
            clearInterval(timer);
            this.isDisable = false;
            this.tips = "获取验证码";
          } else {
            this.tips = `${count}s`;
          }
        }, 1000);

        sendCode({ phone: this.infoList.phone, type: 1 })
          .then(() => {
            this.$message.success("验证码已发送");
          })
          .catch(() => {
            this.isDisable = false;
            this.tips = "获取验证码";
            clearInterval(timer);
          });
      }
    },
    async btnClcik() {
      if (this.phoneList.phone) {
        this.isDisable = true;
        let count = 60;
        this.tips = `${count}s`;
        let timer = setInterval(() => {
          count--;
          if (count <= 0) {
            clearInterval(timer);
            this.isDisable = false;
            this.tips = "获取验证码";
          } else {
            this.tips = `${count}s`;
          }
        }, 1000);

        sendCode({ phone: this.phoneList.phone, type: 0 })
          .then(() => {
            this.$message.success("验证码已发送");
          })
          .catch(() => {
            this.isDisable = false;
            this.tips = "获取验证码";
            clearInterval(timer);
          });
      }
    },
    changePhone() {
      let newPhone = this.infoList.hiddenPhone
        .replace(/\*/, this.phoneList.hiddenPhoneN)
        .replace(/\*/g, "");
      if (newPhone == this.infoList.phone) {
        this.dialogVisiblePhone = false;
        this.dialogVisiblePhone2 = true;
        this.phoneList.hiddenPhoneN = "";
      } else {
        this.$message.error("手机号错误");
      }
    },
    submitPhone() {
      const { success } = sendPhone(this.phoneList);
      if (!success) {
        this.$message({
          message: "请求成功",
          type: "success"
        });
        this.dialogVisiblePhone2 = false;
        this.phoneList.phone = "";
        this.phoneList.code = "";
        setTimeout(() => {
          this.$nextTick(function() {
            getStudentInfo().then(res => {
              this.infoList = res.data;
              var reg = /^(\d{3})\d{4}(\d{4})$/;
              this.infoList.hiddenPhone = this.infoList.phone;
              this.infoList.hiddenPhone = this.infoList.hiddenPhone.replace(
                reg,
                "$1****$2"
              );
            });
          });
        }, 2000);
      }
    },
    changeStudentId() {
      if (this.phoneList.newstudentno) {
        const { success } = sendStudentno({
          phone: this.infoList.phone,
          code: this.phoneList.code,
          newstudentno: this.phoneList.newstudentno,
          userNumber: this.infoList.userNumber
        });
        this.dialogVisibleNum = false;
        if (!success) {
          this.$message({
            message: "请求成功",
            type: "success"
          });

          this.phoneList.newstudentno = "";
          this.phoneList.code = "";

          setTimeout(() => {
            this.$nextTick(function() {
              getStudentInfo().then(res => {
                this.infoList.studentNo = res.data.studentNo;
              });
            });
          }, 2000);
        }
      } else {
        this.$refs.NumRulesForm.validate("newstudentno");
      }
    },
    cancel() {
      this.dialogVisiblePassWord = false;
      this.phoneList.password = "";
      this.dialogVisiblePhone2 = false;
      this.phoneList.phone = "";
      this.phoneList.code = "";
      this.dialogVisibleNum = false;
      this.phoneList.newstudentno = "";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

.user-center-page {
  background-color: #f5f7fa;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}

.page-header {
  background: #fff;
  border-radius: 12px;
  padding: 0 24px;
  height: 64px !important;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .header-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logout-btn {
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
  }
}

.page-main {
  background: #fff;
  border-radius: 12px;
  padding: 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  overflow-y: auto;
}

.user-profile-card {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 48px;

  .avatar-wrapper {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    padding: 5px;
    background: linear-gradient(135deg, #2563eb, #60a5fa);
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
    margin-bottom: 16px;

    .avatar-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      background: #fff;
      border: 3px solid #fff;
    }
  }

  .user-name {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 8px 0;
  }

  .user-no-text {
    font-size: 15px;
    color: #64748b;
    margin: 0;
  }
}

.info-grid-container {
  width: 100%;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.info-grid {
  display: grid;
  grid-template-columns: 140px 1fr 140px 1fr;
  width: 100%;

  .grid-item {
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
    font-size: 15px;
    display: flex;
    align-items: center;

    &.label {
      background-color: #f1f5f9;
      color: #334155;
      font-weight: 600;
      justify-content: center;
      border-right: 1px solid #e2e8f0;
    }

    &.value {
      background-color: #fff;
      color: #1e293b;
      border-right: 1px solid #e2e8f0;

      &:nth-child(4n) {
        border-right: none;
      }
    }

    &.full-width {
      grid-column: span 3;
    }

    &.last-row {
      border-bottom: none;
    }
  }
}

.info-text {
  margin-right: 12px;
}

.action-link {
  font-size: 14px;
  font-weight: 500;
}

/* 弹窗样式优化 */
.premium-dialog {
  border-radius: 16px;
  overflow: hidden;

  ::v-deep .el-dialog__header {
    background: #f8fafc;
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;

    .el-dialog__title {
      font-weight: 700;
      color: #1e293b;
      font-size: 17px;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
  }
}

.dialog-info-text {
  background: #eff6ff;
  color: #2563eb;
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
  font-size: 16px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.code-input-wrapper {
  display: flex;
  gap: 12px;

  .el-input {
    flex: 1;
  }

  .get-code-btn {
    width: 120px;
    flex-shrink: 0;
  }
}

.phone-hint {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}
</style>
